import React from 'react';
import SVGComponent from '../../generic/svgcomponent';
import "./style.scss";


const Homepage = () => {
  return (
    <div className='home-container'>
      <SVGComponent />
    </div>
  )
}

export default Homepage;